import { Button, Stack, Typography } from "@mui/material";
import Modal from "@/components/modal";
import { toast } from "sonner";
import { useDeleteUrlRedirectMutation } from "@/app/features/urlRedirect/urlRedirectApiSlice";

export default function RedirectDeleteModal({
  open,
  handleClose,
  selectedItem,
}) {
  const [deleteUrlRedirect, { isLoading }] = useDeleteUrlRedirectMutation();

  const handleDelete = async () => {
    try {
      const result = await deleteUrlRedirect(selectedItem.id);
      if (result?.error) {
        toast.error(result.error?.data?.message || "Failed to delete");
        return;
      }
      toast.success("Redirect deleted");
      handleClose();
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Delete redirect?
      </Typography>
      <Typography sx={{ mb: 2 }}>
        Are you sure you want to delete the redirect from{" "}
        &quot;{selectedItem?.fromPath}&quot; to &quot;{selectedItem?.toPath}&quot;?
      </Typography>
      <Stack direction="row" alignItems="center" justifyContent="center" mt={2}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleDelete}
          disabled={isLoading}
        >
          Delete
        </Button>
      </Stack>
    </Modal>
  );
}
